<div>
    <div *ngIf="context.hasText('step-complements-description')" class="with-icon mat-caption">
        <mat-icon matPrefix>info</mat-icon><span class="ml" [innerHtml]="context.getText('step-complements-description')"></span>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-around" fxLayoutGap="10px" fxLayout.lt-sm="column" *ngIf="!context.getOption('step-complements-show-sources')">
        <mat-form-field fxFlex="100%" fxFlex.sm="100%">
            <textarea [placeholder]="context.getText('step-complements-placeholder-source', 'Comment nous avez-vous connu ?')" name="sourceComplements" matInput [(ngModel)]="demande.source" [required]="context.getOption('step-complements-required-source')"></textarea>
            <mat-icon *ngIf="context.hasText('step-complements-tooltip-source')" matSuffix [matTooltip]="context.getText('step-complements-tooltip-source')">help</mat-icon>
        </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-around" fxLayoutGap="10px" fxLayout.lt-sm="column" *ngIf="context.getOption('step-complements-show-sources') && origines.length > 0">
        <mat-form-field fxFlex="100%" fxFlex.sm="100%">
            <mat-label>{{ context.getText('step-complements-placeholder-source', 'Comment nous avez-vous connu ?') }}</mat-label>
            <mat-select name="sourceDemande" required [(ngModel)]="demande.source">
                <mat-option *ngFor="let origine of origines" [value]="origine">{{ origine }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-around" fxLayoutGap="10px" fxLayout.lt-sm="column" *ngIf="context.getOption('step-complements-show-sources') && (demande.source == 'autre' || origines.length == 0)">
        <mat-form-field fxFlex="100%" fxFlex.sm="100%">
            <textarea placeholder="Précisions" name="sourceAutreComplements" matInput [(ngModel)]="demande.sourceAutre"></textarea>
        </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-around" fxLayoutGap="10px" fxLayout.lt-sm="column">
        <mat-form-field fxFlex="100%" fxFlex.sm="100%">
            <textarea [placeholder]="context.getText('step-complements-placeholder-complements', 'Compléments')" name="complementsComplements" matInput [(ngModel)]="demande.complements" [required]="context.getOption('step-complements-required-complements')"></textarea>
            <mat-icon *ngIf="context.hasText('step-complements-tooltip-complements')" matSuffix [matTooltip]="context.getText('step-complements-tooltip-complements')">help</mat-icon>
        </mat-form-field>
    </div>
</div>